import Types from "./types"

export const setTheme = (payload) => ({
  type: Types.SET_THEME,
  payload,
})



// WEBPACK FOOTER //
// ./src/store/action/theme.js